<template>
  <div class="car-content car-main-tab-content">
    <back-btn v-if="displayBackBtn" />
    <spinner v-if="loading" class="car-spinner car-main-content-spinner car-reduced-width" />

    <div class="car-selection-overview car-reduced-width" v-if="!loading">
      <selected-vehicle-tile />
      <selected-region-tile />
      <selected-services-tile />
    </div>

    <div class="car-offer-selection" v-if="!loading">
      <div data-js="offer-selection" v-if="offers.length">

        <offer-list-header :show-location-details="showLocationDetails" />

        <div class="car-filter-sort-box" v-if="showLocationDetails">
          <drop-down :options="statuses"
                     :selected-option="sortName"
                     @change="setSort"
          />
          <div class="car-sort" @click="flipSort">
            <span class="car-icon"></span>
          </div>
        </div>

        <div class="car-offer-list">
          <offer-list-item v-for="(offer, index) in offersSorted" :key="index" :show-location-details="showLocationDetails" :offer="offer" />
        </div>

      </div>
      <div v-else class="car-reduced-width">
        {{$t('offerSelection.header.noOffers')}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import OfferListItem from '@/components/offerSelection/OfferListItem';
import { cloneDeep, get } from 'lodash';
import OfferListHeader from '@/components/offerSelection/OfferListHeader';
import SelectedServicesTile from '@/components/serviceSelection/SelectedServicesTile';
import SelectedVehicleTile from '@/components/vehicleIdentification/SelectedVehicleTile';
import BackBtn from '@/components/BackBtn';
import SelectedRegionTile from '@/components/serviceSelection/SelectedRegionTile';
import Spinner from 'vue-simple-spinner';
import DropDown from '@/components/DropDown';

export default {
  name: 'OfferSelection',
  components: {
    DropDown,
    BackBtn,
    SelectedVehicleTile,
    SelectedServicesTile,
    OfferListHeader,
    OfferListItem,
    SelectedRegionTile,
    Spinner
  },
  data: function() {
    return {
      sort: null,
      loading: false,
      displayBackBtn: true,
      sortName: 'distance'
    }
  },
  methods: {
    ...mapMutations('vehicleIdentification', {
      setVehicleType: 'SET_VEHICLETYPE'
    }),
    ...mapMutations('vehicleServices', {
      setSelectedServices: 'SET_SELECTED_SERVICES'
    }),
    setSort(status) {
      this.sortName = status.key;
      this.sort = status.propName;
    },
    flipSort() {
      if (this.sort && this.sort[0] === '-') {
        this.sort = this.sort.slice(1);
      } else if (this.sort) {
        this.sort = `-${this.sort}`;
      }
    },
    setOfferDetail: function(res) {
      this.setVehicleType({
        name: res.data.vehicleConfig.vehicleTypeName
      });
      this.setSelectedServices(res.data.services);
    }
  },
  created() {
    this.loading = true;
    let promises = [];
    if (!this.offers.length) {
      this.displayBackBtn = false;
      promises.push(this.$store.dispatch('offer/getOfferSearch', this.$route.params.searchKey).then(this.setOfferDetail));
      promises.push(this.$store.dispatch('offer/getOfferListByOfferSearchId', this.$route.params.searchKey));
    }
    promises.push(this.$store.dispatch('offer/getPartQualityTypeList'));
    promises.push(this.$store.dispatch('offer/getGuildList'));

    Promise.all(promises)
      .finally(() => { this.loading = false; })
  },
  computed: {
    ...mapGetters('offer', ['offers', 'partQualityTypes', 'statuses', 'regionSignature']),
    offersSorted() {
      if (!this.sort) return this.offers;
      return this.sort[0] === '-'
        ? cloneDeep(this.offers).sort((a, b) => a[this.sort.slice(1)] > b[this.sort.slice(1)] ? 1 : -1)
        : cloneDeep(this.offers).sort((a, b) => a[this.sort] > b[this.sort] ? -1 : 1);
    },
    showLocationDetails() {
      return !(get(this, '$SMP_CONFIG.contextConfig.extended.featureConfig.dealer') === 'single') || !!this.regionSignature;
    }
  }
}
</script>
